import type { SelectableCardProps } from "./types-selectable-card";
import { useSelectableCard } from "./use-selectable-card";
import { SelectableCardView } from "./view-selectable-card";

/**
 * Cartão de escolha única (Figma `work-conflict-card` / `escopo-row`, 10655:114998): casca com a moldura e o estado
 * (selecionado, não selecionado, desabilitado); o corpo vem por `children`. Dentro do `RadioGroup.Root` herda `name`,
 * seleção e desabilitado do grupo. `control="radio"` mostra o rádio à esquerda; `control="none"` esconde o rádio.
 */
export function SelectableCard<T = string>(props: SelectableCardProps<T>) {
  const viewModel = useSelectableCard(props);

  return <SelectableCardView {...viewModel} />;
}
SelectableCard.displayName = "SelectableCard";
